import { motion } from "framer-motion";
import {
  Sparkles,
  ArrowRight,
  Award,
  Quote,
} from "lucide-react";
import { backendUrl } from "../services/backendUrl";

export default function FounderSection() {
  return (
    <section
      id="founder"
      className="relative overflow-hidden bg-white py-24 lg:py-32"
    >
      {/* Background Effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute left-20 top-20 h-80 w-80 rounded-full bg-pink-100 blur-3xl opacity-40" />

        <div className="absolute right-20 bottom-20 h-96 w-96 rounded-full bg-purple-100 blur-3xl opacity-40" />

        <div className="absolute left-0 top-0 h-full w-full bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] bg-[size:80px_80px]" />

        <div className="absolute left-10 top-10 h-32 w-32 rounded-full border border-gray-200" />

        <div className="absolute right-10 top-20 h-20 w-20 rounded-full border border-pink-200" />

        <div className="absolute bottom-20 left-1/2 h-px w-[85%] -translate-x-1/2 bg-gradient-to-r from-transparent via-gray-200 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-12">
        <div className="grid items-center gap-16 lg:grid-cols-[0.9fr_1.1fr]">
       
{/* IMAGE SIDE */}
<motion.div
  initial={{ opacity: 0, x: -60 }}
  whileInView={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.8 }}
  viewport={{ once: true }}
  className="flex justify-center"
>
  <div className="relative">

    {/* Glow Effects */}
    <div className="absolute -left-20 top-10 h-96 w-96 rounded-full bg-pink-400/20 blur-3xl" />
    <div className="absolute -right-20 bottom-10 h-96 w-96 rounded-full bg-purple-400/20 blur-3xl" />

    {/* Main Image */}
    <div className="relative overflow-hidden rounded-[40px] border border-white/50 bg-white/80 p-4 backdrop-blur-xl shadow-[0_40px_120px_rgba(90,45,130,0.15)]">
      <img
        src={backendUrl("/founder.webp")}
        alt="S. K. Selvasubramanian, Managing Director of Sanggavai Constructions"
        width="1054"
        height="1492"
        loading="lazy"
        className="w-full max-w-[500px] rounded-[32px] object-cover"
      />
    </div>

    {/* Experience Badge */}
    <div className="absolute bottom-[0.9rem] left-6 z-20">
      <div className="rounded-3xl bg-gradient-to-r from-[#D94F8A] to-[#A54285] px-8 py-5 text-white shadow-[0_25px_80px_rgba(217,79,138,.35)]">
        <h3 className="text-5xl font-bold pb-3">35+</h3>
        <p className="text-xs uppercase tracking-[0.3em]">
          Years Experience
        </p>
      </div>
    </div>

    {/* Award Badge */}
{/* Award Badge */}
<div className="absolute right-[-20px] top-12 z-20 hidden lg:block">
  <div className="flex items-center gap-3 rounded-2xl bg-white px-5 py-4 shadow-2xl">
    <Award className="h-8 w-8 text-[#D94F8A]" />
    <div>
      <h4 className="font-bold text-gray-900">
        Trusted Legacy
      </h4>
      <p className="text-xs text-gray-500">
        Since 1989
      </p>
    </div>
  </div>
</div>

   
  </div>
</motion.div>

          {/* CONTENT SIDE */}
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            {/* Badge */}
            <div className="inline-flex items-center gap-2 rounded-full border border-pink-200 bg-pink-50 px-5 py-2">
              <Sparkles className="h-4 w-4 text-pink-600" />

              <span className="text-xs font-semibold uppercase tracking-[0.35em] text-purple-700">
                Visionary Leadership
              </span>
            </div>

            {/* Name */}
            <h2 className="mt-8 font-serif leading-[0.95] text-[#111827]">
              <span className="block text-5xl md:text-6xl lg:text-7xl">
                SK
              </span>

              <span className="block bg-gradient-to-r from-[#D94F8A] to-[#A54285] bg-clip-text text-5xl text-transparent md:text-6xl lg:text-7xl">
                Selvasubramanian
              </span>
            </h2>

            {/* Designation */}
            <div className="mt-8 flex items-center gap-5">
              

              <span className="text-sm font-medium uppercase tracking-[0.4em] text-gray-500">
                Managing Director
              </span>

              <div className="h-px w-24 bg-gray-300" />
            </div>

            {/* Description */}
            <p className="mt-10 max-w-2xl text-lg leading-9 text-gray-600">
              Leading with an elevated blend of craftsmanship,
              innovation, and client-centric precision, he
              delivers premium residential and landmark
              projects that define modern luxury and
              enduring value while maintaining an unwavering
              commitment to excellence and customer trust.
            </p>

            {/* Cards */}
            <div className="mt-12">
             

              {/* Quote */}
              <div className="group relative rounded-[32px] border border-pink-100 bg-[#FCF7FB] p-8 shadow-[0_25px_80px_rgba(90,45,130,0.08)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_35px_100px_rgba(90,45,130,0.15)]">
                <Quote className="absolute right-6 top-6 h-12 w-12 text-pink-200" />

                <p className="text-xs uppercase tracking-[0.4em] text-purple-700">
                  Quote
                </p>

                <p className="mt-6 text-lg font-medium leading-8 text-gray-800">
                  Building is not just our work,
                  it’s our commitment to excellence.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-12 flex flex-col gap-5 lg:flex-row lg:items-center">
             <a
  href={`https://wa.me/919150035559?text=${encodeURIComponent(
    `Hi Sanggavai Constructions,

I would like to schedule a consultation regarding my construction project.

Please contact me to discuss my requirements.

Thank you.`
  )}`}
  target="_blank"
  rel="noopener noreferrer"
  className="group inline-flex items-center justify-center rounded-full bg-gradient-to-r from-[#D94F8A] to-[#A54285] px-10 py-5 font-semibold text-white shadow-[0_20px_50px_rgba(217,79,138,0.35)] transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_30px_70px_rgba(217,79,138,0.45)]"
>
  Schedule a Consultation

  <ArrowRight className="ml-3 h-5 w-5 transition-transform duration-300 group-hover:translate-x-2" />
</a>

              <div className="flex items-center gap-3 text-sm text-gray-500">
                <span className="h-px w-16 bg-gray-300" />
                Trusted by premium builders
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
